<template>
<m-pageframe
    :title="title"
>
<v-container
    fluid
    style="padding: 30px; padding-top: 0px;"
    v-if="profile != null"
>

<v-expansion-panels
  style="margin-top: 15px"
>
    <v-expansion-panel>
      <m-welcome-expansion-panel-header
        label="General Information"
        complete
        :step_number="1"
      />
      <v-expansion-panel-content>
        <m-provision-general
            :profile="profile"
            v-on:reload="update"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
      <m-welcome-expansion-panel-header
        label="Notes"
        :complete="profile.provision_info.complete_note"
        :step_number="2"
      />
      <v-expansion-panel-content>
        <m-provision-note
            :profile="profile"
            v-on:reload="update"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
      <m-welcome-expansion-panel-header
        label="Integrations"
        :complete="profile.provision_info.complete_integrations"
        :step_number="3"
      />
      <v-expansion-panel-content>
        
        <m-welcome-integrations
          :profile="profile"
          v-on:reload="update"
          provision
        />
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
      <m-welcome-expansion-panel-header
        label="Phone Number Plan"
        :complete="profile.provision_info.complete_phone_number_plan"
        :step_number="4"
      />
      <v-expansion-panel-content>
        <m-provision-phone-number-plan
          :profile="profile"
          v-on:reload="update"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
      <m-welcome-expansion-panel-header
        label="Rate Card & Billing"
        :complete="profile.provision_info.complete_rate_card"
        :step_number="5"
      />
      <v-expansion-panel-content>
        <m-provision-rate-card
            :profile="profile"
            v-on:reload="update"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
      <m-welcome-expansion-panel-header
        label="Team"
        :complete="profile.provision_info.complete_team"
        :step_number="6"
      />
      <v-expansion-panel-content>
        <m-provision-team
            :profile="profile"
            v-on:reload="update"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
      <m-welcome-expansion-panel-header
        label="Features"
        :complete="profile.provision_info.complete_features"
        :step_number="7"
      />
      <v-expansion-panel-content>
       <m-provision-features
          :profile="profile"
          v-on:reload="update"
       />
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
      <m-welcome-expansion-panel-header
        label="The Campaign Registry (TCR)"
        :complete="profile.provision_info.complete_tcr"
        :step_number="8"
      />
      <v-expansion-panel-content>
       <m-provision-tcr
          :profile="profile"
          v-on:reload="update"
       />
      </v-expansion-panel-content>
    </v-expansion-panel>

    

</v-expansion-panels>

<m-provision-footer
  :profile="profile"
  style="margin-top: 15px"
  v-on:reload="update"
/>

</v-container>
</m-pageframe>
</template>

<script>
export default {
    data() {
        return {
            profile: null,
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        update() {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'GET: /api/v1/provision/get-profile/:organization_id',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                    },
            
                'on_success': (data) => {
                        this.profile = data;
                    },
            
                'on_error': 'Unable to load provision profile',
            });
        }
    },

    computed: {
      title() {
        if ( this.profile == null ) 
          return 'Provision';

        return 'Provision: '+this.profile.organization_account.label;
      },
    },

    watch: {
      $route (to, from){
          this.update();
      }
    },
}
</script>

<style lang="scss" scoped>
</style>